import AccountSelect from '../../../components/common/AccountSelect';

const ExpenseForm = ({form, onChange, accounts, editId, onSubmit, onCancel, saving}) => {
    const set = (key, val) => onChange({...form, [key]: val});
    const canSubmit = form.accountId && form.amount && form.currencyCode && form.occurredOn;

    return (
        <form className="tx-form" onSubmit={(e) => { e.preventDefault(); if (canSubmit) onSubmit(); }}>
            <h3 className="tx-form__title">{editId ? 'Edit Expense' : 'Add Expense'}</h3>

            <div className="tx-form__row">
                <div className="tx-form__field">
                    <label className="tx-form__label">Date</label>
                    <input className="tx-form__input" type="date" value={form.occurredOn}
                           onChange={e => set('occurredOn', e.target.value)} required/>
                </div>
                <div className="tx-form__field">
                    <label className="tx-form__label">Currency</label>
                    <input className="tx-form__input" placeholder="EUR" maxLength={3}
                           value={form.currencyCode}
                           onChange={e => set('currencyCode', e.target.value.toUpperCase())} required/>
                </div>
            </div>

            <div className="tx-form__row">
                <div className="tx-form__field">
                    <label className="tx-form__label">Account</label>
                    <AccountSelect
                        accounts={accounts}
                        value={form.accountId}
                        onChange={v => set('accountId', v)}
                    />
                </div>
                <div className="tx-form__field">
                    <label className="tx-form__label">Amount</label>
                    <input className="tx-form__input" type="number" step="0.01" placeholder="0.00"
                           value={form.amount} onChange={e => set('amount', e.target.value)} required/>
                </div>
            </div>

            <div className="tx-form__field">
                <label className="tx-form__label">Title <span className="tx-form__optional">(optional)</span></label>
                <input className="tx-form__input" placeholder="Expense"
                       value={form.title} onChange={e => set('title', e.target.value)}/>
            </div>

            <div className="tx-form__field">
                <label className="tx-form__label">Notes <span className="tx-form__optional">(optional)</span></label>
                <textarea className="tx-form__input tx-form__textarea" value={form.notes}
                          onChange={e => set('notes', e.target.value)} rows={2}/>
            </div>

            <div className="tx-form__actions">
                <button type="button" className="tx-form__btn" onClick={onCancel}>Cancel</button>
                <button type="submit" className="tx-form__btn tx-form__btn--primary"
                        disabled={!canSubmit || saving}>
                    {saving ? 'Saving…' : editId ? 'Save' : 'Add Expense'}
                </button>
            </div>
        </form>
    );
};

export default ExpenseForm;